import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class PostalCodes extends Component {
  render() {
    return (
      <EntityList apiRoute='api/postalcodes' title="Codes postaux" editTitle="Code postal" displayColumns={[
        {Description: 'Code', Column: 'Code'},
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default PostalCodes;



/** WEBPACK FOOTER **
 ** ./src/app/routes/general/PostalCodes.js
 **/